import { defineMessages } from 'react-intl';

export default defineMessages({
    lossLocationHeading: {
        id: 'tdic.fnol.common.directives.loss-location.Loss Location',
        defaultMessage: 'Loss Location'
    },
    insuredLocation: {
        id: 'tdic.fnol.common.directives.loss-location.Insured Location',
        defaultMessage: 'Insured Location'
    },
    addressLine1: {
        id: 'tdic.inputs.address-details.Address Line 1',
        defaultMessage: 'Address Line 1'
    },
    addressLine2: {
        id: 'tdic.inputs.address-details.Address Line 2',
        defaultMessage: 'Address Line 2'
    }
});
